import * as types from './mutation-types'

const namespaced = true

const initialState = {
  screenWidth: 0,
  mobile: false,
  mobilePhone: false,
  timeline: false,
  search: false,
  menu: false
}

const mutations = {
  [types.SET_SCREEN_WIDTH] (state, width) {
    state.screenWidth = width
  },
  [types.SET_MOBILE] (state, isMobile) {
    state.mobile = isMobile
  },
  [types.SET_MOBILE_PHONE] (state, isMobile) {
    state.mobilePhone = isMobile
  },
  [types.TOGGLE_TIMELINE] (state, timeline) {
    if (timeline === true || timeline === false) {
      state.timeline = timeline
    } else {
      state.timeline = !state.timeline
    }
    if (state.timeline) {
      state.search = false
      state.menu = false
    }
  },
  [types.TOGGLE_SEARCH] (state, search) {
    if (search === true || search === false) {
      state.search = search
    } else {
      state.search = !state.search
    }
    if (state.search) {
      state.timeline = false
      state.menu = false
    }
  },
  [types.TOGGLE_CLOSED] (state) {
    state.search = false
    state.timeline = false
    state.menu = false
  },
  [types.TOGGLE_MENU] (state, menu) {
    if (menu === true || menu === false) {
      state.menu = menu
    } else {
      state.menu = !state.menu
    }
    if (state.menu) {
      state.timeline = false
      state.search = false
    }
  }
}

const actions = {
  setWidth: ({ commit }, width) => {
    commit(types.SET_SCREEN_WIDTH, width)
    if (width < 960) {
      commit(types.SET_MOBILE, true)
    } else {
      commit(types.SET_MOBILE, false)
    }

    if (width < 420) {
      commit(types.SET_MOBILE_PHONE, true)
    } else {
      commit(types.SET_MOBILE_PHONE, false)
    }
  },
  toggleTimeline: ({ commit }, timeline) => {
    commit(types.TOGGLE_TIMELINE, timeline)
  },
  toggleSearch: ({ commit }, search) => {
    commit(types.TOGGLE_SEARCH, search)
  },
  toggleClosed: ({ commit }) => {
    commit(types.TOGGLE_CLOSED)
  },
  toggleMenu: ({ commit }, menu) => {
    commit(types.TOGGLE_MENU, menu)
  }
}

const getters = {
  screenWidth (state) {
    return state.screenWidth
  },
  mobile (state) {
    return state.mobile
  },
  mobilePhone (state) {
    return state.mobilePhone
  },
  timeline (state) {
    return state.timeline
  },
  search (state) {
    return state.search
  },
  menu (state) {
    return state.menu
  }
}

export default {
  namespaced,
  state: initialState,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/modules/ux.js